import { ResourcesPage } from './pages';

export const resourcesRoutes = [
  {
    path: 'resources',
    component: ResourcesPage,
    requiredPermission: 'resources.view',
  },
];
